import { Table } from '@flos/react-ui';
import NavToElementPage from '../components/navigation/NavToElementPage';

type SummaryRowProps = {
    elementId: string;
    caption: string | JSX.Element | undefined;
    value: string | JSX.Element | JSX.Element[] | undefined;
};

/**
 * Template for a row in the summary page
 * @param props
 * @returns
 */
export const SummaryRowTemplate = (props: SummaryRowProps): JSX.Element => {
    const { elementId, caption, value } = props;

    return (
        <Table.Row>
            <Table.HeadCell scope="row" valign="top">
                <h6 className="row-caption">{caption}</h6>
            </Table.HeadCell>
            <Table.Cell>
                <div className="value-cell">
                    <span style={{ overflowWrap: 'anywhere' }}>{value}</span> {/*so long words are broken*/}
                    <NavToElementPage elementId={elementId} />
                </div>
            </Table.Cell>
        </Table.Row>
    );
};
